import React, { useEffect } from "react";

type AgentSideDrawerProps = {
    children: React.ReactNode;
    open: boolean;
    closeModal?: () => void;
    sideDrawerClassName?: string;
    modalRef?: React.RefObject<HTMLDivElement>;
};

const AgentSideDrawer = ({
    children,
    open,
    sideDrawerClassName,
    modalRef,
    closeModal,
}: AgentSideDrawerProps) => {

    return (
        <div className="" ref={modalRef} >
            <div
                id="modal"
                className={`w-[90%] md:w-[600px] max-w-[600px] fixed z-[1000] bg-white  top-[250px]  lg:top-[195px] h-[calc(100vh-250px)] lg:h-[calc(100vh-195px)] transition-all duration-500 ease-in-out flex flex-col lg:pt-1 ${
                    open ? "lg:right-[58px] right-8" : "right-[-1000px]"
                } ${sideDrawerClassName}`}
            >
                <div
                    className="flex-grow overflow-y-auto scrollbar-hide"
                    onClick={(evt) => {
                        // evt.stopPropagation();
                    }}
                    onMouseDown={(evt) => {
                        // evt.stopPropagation();
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AgentSideDrawer;
